import { render, staticRenderFns } from "./companyConsumer.vue?vue&type=template&id=0698db8d&scoped=true&"
import script from "./companyConsumer.vue?vue&type=script&lang=js&"
export * from "./companyConsumer.vue?vue&type=script&lang=js&"
import style0 from "./companyConsumer.vue?vue&type=style&index=0&id=0698db8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698db8d",
  null
  
)

export default component.exports